// src/router/adminRoutes.js

// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Admin Views
const AdminLeadPage = () => import('@/modules/admin/views/AdminLeadPage')
const AdminDashboard  = () => import('@/modules/admin/views/AdminDashboard')
const NewAdminDashboard  = () => import('@/modules/admin/views/NewAdminDashboard')
const AdminReadyToReviewList  = () => import('@/modules/admin/views/AdminReadyToReviewList')
const AdminVerificationCallList  = () => import('@/modules/admin/views/AdminVerificationCallList')
const AdminIncompleteList  = () => import('@/modules/admin/views/AdminIncompleteList')
const AdminReadyToSubmitList  = () => import('@/modules/admin/views/AdminReadyToSubmitList')
const AdminSubmittedList  = () => import('@/modules/admin/views/AdminSubmittedList')
const AdminPendingUnderwritingList  = () => import('@/modules/admin/views/AdminPendingUnderwritingList')
const AdminResubmitToUnderwritingList  = () => import('@/modules/admin/views/AdminResubmitToUnderwritingList')
const AdminAddEquipmentList  = () => import('@/modules/admin/views/AdminAddEquipmentList')
const AdminNotInInstalls  = () => import('@/modules/admin/views/AdminNotInInstalls')
const AdminDeclinedList  = () => import('@/modules/admin/views/AdminDeclinedList')

const routes = [
  {
    path: '/admin',
    redirect: '/admin/new-dashboard',
    component: DefaultContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: AdminLeadPage,
        children: [
          {
            path: 'dashboard',
            name: 'AdminDashboard',
            component: NewAdminDashboard,
            meta: { tab: 'dashboard', role_filter: 'closer' },
          },
          {
            path: 'new-dashboard',
            name: 'NewAdminDashboard',
            component: NewAdminDashboard,
            meta: { tab: 'new-dashboard', role_filter: 'closer' },
          },
          {
            path: 'ready-to-review',
            name: 'AdminReadyToReviewList',
            component: AdminReadyToReviewList,
            meta: { tab: 'ready-to-review', role_filter: 'closer' },
          },
          {
            path: 'verify-call',
            name: 'AdminVerificationCallList',
            component: AdminVerificationCallList,
            meta: { tab: 'verify-call', role_filter: 'closer' },
          },
          {
            path: 'incomplete',
            name: 'AdminIncompleteList',
            component: AdminIncompleteList,
            meta: { tab: 'incomplete', role_filter: 'closer' },
          },
          {
            path: 'ready-to-submit',
            name: 'AdminReadyToSubmitList',
            component: AdminReadyToSubmitList,
            meta: { tab: 'ready-to-submit', role_filter: 'closer' },
          },
          {
            path: 'submitted',
            name: 'AdminSubmittedList',
            component: AdminSubmittedList,
            meta: { tab: 'submitted', role_filter: 'closer' },
          },
          {
            path: 'pending-underwriting',
            name: 'AdminPendingUnderwritingList',
            component: AdminPendingUnderwritingList,
            meta: { tab: 'pending-underwriting', role_filter: 'closer' },
          },
          {
            path: 'resubmit-to-underwriting',
            name: 'AdminResubmitToUnderwritingList',
            component: AdminResubmitToUnderwritingList,
            meta: { tab: 'resubmit-to-underwriting', role_filter: 'closer' },
          },
          {
            path: 'add-equipment',
            name: 'AdminAddEquipmentList',
            component: AdminAddEquipmentList,
            meta: { tab: 'add-equipment', role_filter: 'closer' },
          },
          {
            path: 'not-in-installs',
            name: 'AdminNotInInstalls',
            component: AdminNotInInstalls,
            meta: { tab: 'not-in-installs', role_filter: 'closer' },
          },
          {
            path: 'declined',
            name: 'AdminDeclinedList',
            component: AdminDeclinedList,
            meta: { tab: 'declined', role_filter: 'closer' },
          },
        ]
      }
    ]
  }
]

export default routes